import React from 'react'
import Status from 'containers/Status'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import Meta from './Meta'

const NotFound = () => {
  const { formatMessage } = useIntl()

  return (
    <Status code={404}>
      <div>
        <Meta />
        <div className="flex justify-center items-center p-12">
          <div className="max-w-xl w-full">
            <FormattedMessage
              {...messages.errorMessage}
              values={{
                h1: (chunk) => <h1 className="text-2xl">{chunk}</h1>,
                p: (chunk) => <p className="my-4">{chunk}</p>,
                span: (chunk) => <span>{chunk}</span>,
                phone_link: (chunk) => (
                  <a href={`tel:${formatMessage(messages.phone_number)}`}>{chunk}</a>
                ),
                email_link: (chunk) => (
                  <a className="text-primary" href={`mailto:${formatMessage(messages.email)}`}>
                    {chunk}
                  </a>
                ),
                link_home_page: (chunk) => (
                  <a className="text-primary" href={formatMessage(messages.url)}>
                    {chunk}
                  </a>
                ),
                email: formatMessage(messages.email),
                phone_number: formatMessage(messages.phone_number),
                url: formatMessage(messages.url),
              }}
            />
          </div>
        </div>
      </div>
    </Status>
  )
}

export default NotFound